import { Component, OnInit } from '@angular/core';
import { OkAloneService } from '../../../ok-alone.service';

import moment from 'moment';
declare var require: any;
//var MobileDetect = require('mobile-detect');


@Component({
  selector: 'app-choose-app',
  templateUrl: './choose-app.component.html',
  styleUrls: ['./choose-app.component.scss']
})
export class ChooseAppComponent implements OnInit {


  year = moment().format('YYYY');
  
  constructor(public okService:OkAloneService) { }

  ngOnInit(): void {
    
    // var md = new MobileDetect(window.navigator.userAgent);

    // if(md.is('iPhone')){
    //   let url = "https://apps.apple.com/gb/app/ok-alone/id777464303";
    //   location.href = url;

    // }else if(md.is('AndroidOS')){

    //   let url = "https://play.google.com/store/apps/details?id=com.trustyox.okalone";
    //   location.href = url;
    // }

  }

}
